import errorReducer from './errorReducer';

export default errorReducer;